"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUrl = void 0;
const getCanonicalLocale_1 = require("./getCanonicalLocale");
const isSpecialUrl_1 = require("./isSpecialUrl");
const parseAsFullyQualifiedURI_1 = require("./parseAsFullyQualifiedURI");
function parseUrl(config, url) {
    if ((0, isSpecialUrl_1.isSpecialUrl)(url)) {
        return {
            cleanUrl: url,
            locale: config.default.locale,
        };
    }
    const { path, origin } = (0, parseAsFullyQualifiedURI_1.parseAsFullyQualifiedURI)(url);
    const trimmedPath = path.charAt(0) === '/' ? path.slice(1) : path;
    const [langPart, ...unlocalizedPath] = trimmedPath.split('/');
    const locale = (0, getCanonicalLocale_1.getCanonicalLocale)(langPart, config.supported.locale);
    if (locale !== null && config.supported.locale.indexOf(locale) !== -1) {
        return { cleanUrl: `${origin}/${unlocalizedPath.join('/')}`, locale };
    }
    return { cleanUrl: origin + path, locale: config.default.locale };
}
exports.parseUrl = parseUrl;
